<template>
  <div class="drag-element-actions left-drag-element-actions">
    <ElTooltip
      v-if="item.isHidden"
      :show-after="300"
      :hide-after="10"
      effect="dark"
      :content="
        item.showFieldInPdf
          ? 'Hide this field in PDF'
          : 'Show this field in PDF'
      "
      placement="left"
    >
      <button
        name="delete"
        class="action-btn pdf-btn"
        @click.stop="set(item, 'showFieldInPdf', !item.showFieldInPdf)"
      >
        <i class="fa-solid fa-file-pdf" />
      </button>
    </ElTooltip>
  </div>
  <div class="drag-element-actions right-drag-element-actions">
    <ElTooltip
      v-if="!noDelete"
      :show-after="300"
      :hide-after="10"
      effect="dark"
      content="Delete"
      placement="right"
    >
      <button
        name="delete"
        class="action-btn action-delete"
        @click.stop="$emit('delete')"
      >
        <DeleteIcon height="16" width="16" />
      </button>
    </ElTooltip>
    <ElTooltip
      v-if="!noDuplicate"
      :show-after="300"
      :hide-after="10"
      effect="dark"
      content="Copy"
      placement="right"
    >
      <button
        name="duplicate"
        class="action-btn action-duplicate"
        @click.stop="$emit('duplicate')"
      >
        <CopyIcon height="16" width="16" color="#0076CB" />
      </button>
    </ElTooltip>
    <ElTooltip
      v-if="!noHide"
      :show-after="300"
      :hide-after="10"
      effect="dark"
      content="Hide"
      placement="right"
    >
      <button
        name="hide"
        class="action-btn action-hide"
        @click.stop="$emit('hide')"
      >
        <HideIcon height="16" width="16" color="#8B8B8B" />
      </button>
    </ElTooltip>

    <ElTooltip
      v-if="!noPageBreak"
      :show-after="300"
      :hide-after="10"
      effect="dark"
      content="Move all the fields below this to a new page"
      placement="right"
    >
      <button
        name="page-break"
        class="action-btn action-page-break"
        @click.stop="$emit('page-break')"
      >
        <PageBreakIcon height="16" width="16" color="#00906E" />
      </button>
    </ElTooltip>
  </div>
</template>

<script setup>
import { ElTooltip } from "element-plus";
import { set } from "lodash-es";

import DeleteIcon from "@/components/icons/delete-icon.vue";
import CopyIcon from "@/components/icons/copy.vue";
import HideIcon from "@/components/icons/hide.vue";
import PageBreakIcon from "@/components/icons/page-break.vue";

const props = defineProps({
  noDuplicate: {
    type: Boolean,
    default: false,
  },
  noDelete: {
    type: Boolean,
    default: false,
  },
  noHide: {
    type: Boolean,
    default: false,
  },
  noPageBreak: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object,
    default: () => ({}),
  },
});

const emits = defineEmits(["delete", "duplicate", "hide", "page-break"]);
</script>

<style>
.drag-wrapper:hover:not(:has(.drag-wrapper:hover)):hover
  > .drag-element-actions {
  visibility: visible;
}

.drag-element-actions {
  top: 45%;
  transform: translateY(-45%);
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 5px;
  z-index: 10;
  visibility: hidden;
}

.action-btn {
  padding: 6px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.action-btn.action-delete {
  background: #fee4e2;
}
.action-btn.action-duplicate {
  background: #e4f4ff;
}
.action-btn.action-hide {
  background: #f2f2f2;
}
.action-btn.action-page-break {
  background: #dcffee;
}

.right-drag-element-actions {
  right: -14px;
}

.left-drag-element-actions {
  left: -14px;
}

.pdf-btn {
  width: 28px;
  height: 28px;
  background-color: wheat;
}
</style>
